import { create } from 'zustand'
import { getSessionStorage, setSessionStorage } from '@utils/states/sessionStorage'

import { getSideBarData } from './provider'

import type { FieldsPersistedDataProps, UseLayoutProps } from './types'

export const useLayout = create<UseLayoutProps>((set) => ({
  fieldsPersistedData: getSessionStorage<FieldsPersistedDataProps>('@SMARTOPS_FIELDS_PERSISTED_DATA') || null,
  setFieldsPersistedData: (value) => {
    set({ fieldsPersistedData: value })
    setSessionStorage('@SMARTOPS_FIELDS_PERSISTED_DATA', value || null)
  },

  sideBarData: [],
  setSideBarData: (value) => set({ sideBarData: value }),

  isSideBarDataLoading: false,
  setIsSideBarDataLoading: (value) => set({ isSideBarDataLoading: value }),

  isMenuOpen: false,
  setIsMenuOpen: (value) => set({ isMenuOpen: value }),

  isMenuCollapsedPersisted: getSessionStorage<boolean | null>('@SMARTOPS_MENU_COLLAPSED') || null,
  setIsMenuCollapsedPersisted: (value) => {
    set({ isMenuCollapsedPersisted: value })
    setSessionStorage('@SMARTOPS_MENU_COLLAPSED', value || null)
  },

  getSideBarData
}))
